import { css } from 'emotion'

const orange = `#FF9933`
const red = `#FF0000`

const colorSwitch = (updated, newItem) => {
  if (newItem.new) {
    return red
  }
  if (updated) {
    return orange
  }
  return 'transparent'
}

const circle = (updated, newItem) => {
  const backgroundColor = colorSwitch(updated, newItem)
  return css`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 0 10px 0 0;
    transition: background-color 0.5s;
    background: ${backgroundColor};
  `
}

export default { circle }
